export default "__VITE_ASSET__Cp7buC87__"